<template>
  <div
    v-show="isShown"
    class="reject-popup"
  >
  <div class="reject-popup__popup">
    <button @click.prevent="cancel" class="reject-popup__close-btn">
      <img src="../assets/cross_icon.svg" alt="Закрыть">
    </button>
    <h2 class="reject-popup__title">Хотите отклонить заявку?</h2>
    <p class="reject-popup__text">
      Она попадет в Архив на 14 дней,<br>
      после чего будет удалена безвозвратно
    </p>
    <div class="reject-popup__button-wrapper">
      <base-button @click="reject" class="reject-popup__button">отклонить</base-button>
      <base-button @click="cancel" class="reject-popup__button">отмена</base-button>
    </div>
  </div>
  </div>
</template>

<script>
import BaseButton from '../components/BaseButton'

export default {
  name: 'RejectPopup',
  components: {
    BaseButton
  },
  props: {
    isShown: {
      required: true,
      type: Boolean,
      default: false
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel-rejection')
    },
    reject() {
      this.$emit('reject')
    }
  }
}
</script>

<style lang="scss" scoped>
@use "../styles/fonts";
@use "../styles/colors";

.reject-popup {
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100vw;
  height: 100vh;
  &__popup {
    position: relative;
    padding: 64px;
    border: solid 1px #000;
    background-color: #fff;
  }
  &__close-btn {
    position: absolute;
    top: 26px;
    right: 26px;
    border: none;
    background-color: transparent;
    cursor: pointer;
    & > img {
      width: 12px;
    }
  }
  &__title {
    font-size: 22px;
    margin-bottom: 16px;
    text-transform: uppercase;
  }
  &__text {
    @include fonts.mo-med;
    font-size: 14px;
    line-height: 19px;
    margin-bottom: 40px;
    color: colors.$gray7f;
  }
  &__button-wrapper {
    display: flex;
    justify-content: space-between;
  }
}

@media screen and (max-width: 767px) {
  .reject-popup {
    &__popup {
      padding: 45px;
    }
    &__close-btn {
      top: 22px;
      right: 22px;
    }
    &__title {
      max-width: 250px;
      line-height: 27px;
    }
    &__text {
      max-width: 250px;
    }
    &__button-wrapper {
      flex-direction: column;
      align-items: center;
      justify-content:center
    }
    &__button {
      width: 250px;
    }
    &__button:first-child {
      margin-bottom: 15px;
    }
  }
}
</style>